import { Routes, Route } from "react-router-dom";
// import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
import AppBar from "./components/AppBar";
import Home from "./components/Home";
import DoctorHome from "./components/doctor/DoctorHome";
import About from "./components/About";
import Services from "./components/Services";
import News from "./components/News";
import Contact from "./components/Contact";
import FootBar from "./components/FootBar";
import Login from "./components/Login";
import Signup from "./components/Signup";
import ForgetPassword from "./components/ForgetPassword";
import Faq from "./components/Faq";
import "./App.css";


function App() {
  return (
    <>
      <AppBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/doctors" element={<DoctorHome />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/news" element={<News />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgetPassword" element={<ForgetPassword />} />
        <Route path="/faq" element={<Faq />} />
      </Routes>
      <FootBar />
    </>
  );
}

export default App;
